import React, { useEffect } from 'react';
import { useCookieSettings } from "./cookieSettingsContext";

const DynamicScriptLoader = () => {
    const googleAnalyticsId = 'G-QDSTJRSXWY';
    const { cookieSettings } = useCookieSettings();

    useEffect(() => {
        if (cookieSettings['Analytics Cookies']) {
            // Load the Google Analytics script
            addGoogleAnalyticsScript();
        } else {
            // Remove Google Analytics cookies when Analytics Cookies are disabled
            deleteAnalyticsCookies();
        }
    }, [cookieSettings]);

    const addGoogleAnalyticsScript = () => {
        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`;
        script.async = true;
        document.head.appendChild(script);

        script.onload = () => {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () { window.dataLayer.push(arguments); };
            window.gtag('js', new Date());
            window.gtag('config', googleAnalyticsId);
        };
    };

    // Function to delete Google Analytics cookies
    const deleteAnalyticsCookies = () => {
        const cookies = document.cookie.split(';');
        cookies.forEach(cookie => {
            const trimmedCookie = cookie.trim();
            const cookieName = trimmedCookie.split('=')[0];
            if (cookieName.match(/^_ga_/) || cookieName === '_ga' || cookieName === '_gid' || cookieName === '_gat') {
                document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=${document.domain};`;
            }
        });
    };

    return null;
};

export default DynamicScriptLoader;